import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { SearchSupportFamiliesResponse, UpdateSupportFamilyBody } from "./types/supportFamilies";

export const useDeckSupportFamiliesApi = () => {
  const crud = createAdminCrudApi<SearchSupportFamiliesResponse, never, UpdateSupportFamilyBody>(
    useApi(),
    DECK_ADMIN_URL,
    "support_families",
  );

  return {
    useDeckSupportFamilies: crud.useSearch,
    getDeckSupportFamilies: crud.search,
    updateDeckSupportFamily: crud.update,
    updateDeckSupportFamilyVisibility: crud.updateVisibility,
    updateDeckSupportFamilyOrder: crud.updateOrder,
  };
};

export default useDeckSupportFamiliesApi;
